import React from "react";
import LegalLayout from "./LegalLayout";
import useSeo from "../lib/useSeo";
import { buildCanonical } from "../lib/insightsLinks";

export default function LegalCookies() {
  useSeo({
    title: "Cookie Policy — Linked2Marketing",
    description:
      "How Linked2Marketing uses cookies and similar technologies on this website, and how you can manage your preferences under UK PECR and UK GDPR.",
    canonical: buildCanonical("/cookies"),
    ogType: "website",
  });

  return (
    <LegalLayout
      eyebrow="Legal · UK PECR"
      title="Cookie Policy"
      intro="This policy explains how Linked2Marketing uses cookies and similar technologies on this website, and how you can manage your preferences. It is written to comply with the Privacy and Electronic Communications Regulations (PECR) and the UK GDPR."
      lastUpdated="28 February 2026"
      testid="page-cookies"
    >
      <h2>1. What cookies are</h2>
      <p>
        Cookies are small text files placed on your device when you visit a
        website. They allow the site to remember your preferences and help us
        understand, in aggregate, how the site is used.
      </p>

      <h2>2. Cookies we use</h2>
      <p>
        We only set non-essential cookies after you have given consent via our
        cookie banner.
      </p>

      <h3>Essential</h3>
      <ul>
        <li>
          <strong>l2m_consent_v1</strong> — stores your cookie preference so we
          do not show the banner on every visit. Set by Linked2Marketing. No
          personal information.
        </li>
        <li>
          <strong>l2m_admin_token</strong> — stored only in the local browser
          when an administrator logs into the CMS. Not set for regular
          visitors.
        </li>
      </ul>

      <h3>Analytics (only after consent)</h3>
      <ul>
        <li>
          <strong>Google Analytics 4</strong> — uses cookies such as <code>_ga</code>{" "}
          and <code>_ga_*</code> to measure aggregate, anonymised website usage.
          Provider: Google Ireland Limited. We only enable this if you click{" "}
          <em>Accept</em> on the cookie banner.
        </li>
      </ul>

      <h2>3. Managing your preferences</h2>
      <p>
        When you first visit the site, you can choose <em>Accept</em> or{" "}
        <em>Decline</em>. If you decline, no analytics cookies will be set. You
        can change your decision at any time by clearing the site cookies in
        your browser, which will cause the banner to appear again on your next
        visit.
      </p>
      <p>
        You can also block or delete cookies in your browser settings. Most
        browsers offer guidance under “Settings” → “Privacy and security”.
      </p>

      <h2>4. Third-party services</h2>
      <p>
        Linked to from this site, we use the following third-party services
        which may set their own cookies on their own domains:
      </p>
      <ul>
        <li>
          <strong>Calendly</strong> — only loaded when you click “Book a 30-min
          consultation”. Calendly’s own cookie and privacy notices apply on
          their domain.
        </li>
      </ul>

      <h2>5. Updates</h2>
      <p>
        We may update this policy when we add or remove services. Material
        changes will be reflected by updating the “Last updated” date above.
      </p>

      <h2>6. Contact</h2>
      <p>
        For any cookie or privacy questions, please contact us at{" "}
        <a href="mailto:contact@linked2marketing.com">contact@linked2marketing.com</a>.
      </p>
    </LegalLayout>
  );
}
